import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import VideoGallery from "./sections/VideoGallery";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <VideoGallery />
      <CallToAction />
      <Footer />
    </div>;
}